import { NoImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { useHandleAction } from "@utils/hook/index.hook";
import { usePreviewVideo, useSelectionStore } from "@utils/states/index.state";
import { useMemo } from "react";

const ColumnList = ({ refetch }: { refetch?: () => void }) => {
  const sucessEndpoint = useMemo(() => endpoint["successstory"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: sucessEndpoint,
    refetch,
  });
  const { setPreviewVideo } = usePreviewVideo();
  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Image / Video",

        cell: (row: any) => {
          return (
            <div className="flex gap-6  ">
              <ZoomImage>
                <img
                  src={row.featured_image || NoImage}
                  alt="featured"
                  onError={(e: any) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = NoImage;
                  }}
                  className="w-12 h-12 object-cover rounded"
                />
              </ZoomImage>

              {row?.testimonial_video && (
                <>
                  <video
                    onClick={() => setPreviewVideo(row?.testimonial_video)}
                    src={row?.testimonial_video}
                    className="w-12 h-12 object-cover cursor-pointer rounded"
                  />
                </>
              )}
            </div>
          );
        },
        sortable: false,
      },
      {
        name: "Title",
        cell: (row: any) => (
          <div className="flex items-center justify-start w-full h-full">
            {" "}
            <Tooltip description={row.title}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {row.title}
                </span>
              </div>
            </Tooltip>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Team Member and Student",
        cell: (row: any) => (
          <div className="flex flex-col gap-2 items-center justify-center w-full h-full">
            {" "}
            <Tooltip description={row?.team_member?.user?.full_name}>
              <div className="text-sm font-medium flex items-center justify-start w-[150px] truncate    line-clamp-1 text-gray-800">
                Team: {row?.team_member?.user?.full_name || "N/A"}
              </div>
            </Tooltip>{" "}
            <Tooltip description={row?.student?.user?.full_name}>
              <div className="text-sm font-medium flex items-center justify-start w-[150px] truncate    line-clamp-1 text-gray-800">
                Student: {row?.student?.user?.full_name || "N/A"}
              </div>
            </Tooltip>
          </div>
        ),
        sortable: true,
      },

      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "page-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection, setPreviewVideo]
  );
  return columns;
};

export { ColumnList };
